/**
 * Import of all the web components available in Nimble.
 * Production applications are encouraged to import only components
 * that are required instead of leveraging this file.
 */

import './anchor';
import './anchor-button';
import './anchor-menu-item';
import './anchor-step';
import './anchor-tab';
import './anchor-tabs';
import './anchor-tree-item';
import './anchored-region';
import './banner';
import './breadcrumb';
import './breadcrumb-item';
import './button';
import './card';
import './card-button';
import './checkbox';
import './chip';
import './combobox';
import './dialog';
import './drawer';
import './icons/all-icons';
import './label-provider/core';
import './label-provider/table';
import './list-option';
import './list-option-group';
import './mapping/empty';
import './mapping/icon';
import './mapping/spinner';
import './mapping/text';
import './menu';
import './menu-button';
import './menu-item';
import './number-field';
import './radio';
import './radio-group';
import './rich-text/editor';
import './rich-text/viewer';
import './select';
import './spinner';
import './step';
import './stepper';
import './switch';
import './tab';
import './tab-panel';
import './table';
import './table-column/anchor';
import './table-column/date-text';
import './table-column/duration-text';
import './table-column/mapping';
import './table-column/menu-button';
import './table-column/number-text';
import './table-column/text';
import './tabs';
import './tabs-toolbar';
import './text-area';
import './text-field';
import './theme-provider';
import './toggle-button';
import './toolbar';
import './tooltip';
import './tree-item';
import './tree-view';
import './unit/byte';
import './unit/volt';
import './wafer-map';
